import React from 'react'
import { Table, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface RelatedExceptionUnusualBehaviorProps {
  data: any
}

export default function RelatedExceptionUnusualBehavior({ data }: RelatedExceptionUnusualBehaviorProps) {
  const theme = useTheme()
  const categories = [
    { label: '银行失联欺诈', normal: data?.aals_00021, serious: data?.aals_00031 },
    { label: '网络小贷欺诈关联', normal: data?.aals_00022, serious: data?.aals_00032 },
    { label: '地方小贷欺诈关联', normal: data?.aals_00023, serious: data?.aals_00033 },
    { label: '消费金融公司欺诈关联', normal: data?.aals_00024, serious: data?.aals_00034 },
    { label: '融资租赁公司欺诈关联', normal: data?.aals_00025, serious: data?.aals_00035 },
    { label: '汽车金融公司欺诈关联', normal: data?.aals_00026, serious: data?.aals_00036 },
    { label: '其他金融公司欺诈关联', normal: data?.aals_00027, serious: data?.aals_00037 },
  ]

  return (
    <div className="mt-2">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        关联人异常行为检测
      </Text>
      <div className="mt-3">
        <Table highlightOnHover withColumnBorders={false} verticalSpacing="sm">
          <Table.Thead>
            <Table.Tr>
              <Table.Th>检查项目</Table.Th>
              <Table.Th>普通异常</Table.Th>
              <Table.Th>严重异常</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {categories.map((item) => (
              <Table.Tr key={item.label}>
                <Table.Td>{item.label}</Table.Td>
                <Table.Td
                  style={{
                    color: item.normal === 1 ? theme.warningColor : theme.primaryColor,
                    fontWeight: item.normal === 1 ? 600 : 500,
                  }}
                >
                  {item.normal === 1 ? '有' : '无'}
                </Table.Td>
                <Table.Td
                  style={{
                    color: item.serious === 1 ? theme.warningColor : theme.primaryColor,
                    fontWeight: item.serious === 1 ? 600 : 500,
                  }}
                >
                  {item.serious === 1 ? '有' : '无'}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </div>
    </div>
  )
}
